import AuthService from '~/services/AuthService';
import LogService from '~/services/LogService';
import IntercomService from '~/services/IntercomService';
import BackgroundProcessesService from '~/services/BackgroundProcessesService';
import i18n from '~/i18n';

export default {
    state: {
        opened: false,
        redirectURL: null,
        isLoggedIn: AuthService.isAuthenticated(),
        helperText: null,

        // Miscellaneous state (See backgroundProcess and actionScheduler)
        shouldOpenOnNewPage: false,
        prevPagePopupOpened: null,
        hasOpenedOnWindowOut: false,
        disableCloseBtn: false,
        disablePopup: false,
    },
    getters: {
        isOpen: state => payload => {
            return state.opened;
        },
        getRedirect: state => payload => state.redirectURL,
        isLoggedIn: state => payload => state.isLoggedIn,
        setIsLoggedIn: state => async isLoggedIn => {
            state.isLoggedIn = isLoggedIn;
            state.opened = false;

            // If logged in, initialize stuff
            if (isLoggedIn) {
                BackgroundProcessesService.clearLogInPopup();
                window.dispatchEvent(new Event('userLoggedIn'));
                return AuthService.loadUserData().finally(() => {
                    LogService.identifyUser();
                });
            }
            return Promise.resolve();
        },
        getDisabledPopup: state => () => state.disablePopup,
        getHelperText: state => payload => state.helperText,
        getDisabledCloseBtn: state => () => state.disableCloseBtn,

        shouldOpenOnNewPage: state => payload => state.shouldOpenOnNewPage,
        prevPagePopupOpened: state => payload => state.prevPagePopupOpened,
        hasOpenedOnWindowOut: state => payload => state.hasOpenedOnWindowOut,
    },
    mutations: {
        toggleOpen: (state, payload) => {
            state.opened = !state.opened;

            if (!state.opened) {
                state.helperText = null;
                state.redirectURL = null;
            }
        },
        setOpen: (state, isOpen) => {
            state.opened = isOpen;
            if (isOpen) {
                BackgroundProcessesService.stopLogInPopup();
            }
        },
        setForcedLogin: state => {
            if (!state.isLoggedIn) {
                state.opened = true;
                state.disableCloseBtn = true;
                state.helperText = i18n.t(
                    'general.dialogs.helperTexts.logInToAccessMoreFeatures'
                );
            }
        },
        setDisabledPopup: state => {
            state.disablePopup = true;
        },
        resetDisabledPopup: state => {
            state.disablePopup = false;
        },
        setRedirect: (state, redirectURL) => {
            state.redirectURL = redirectURL;
        },
        setHelperText: (state, helperText) => {
            state.helperText = helperText;
        },
        requireLogIn: (state, redirectUrl) => {
            state.opened = true;
            state.redirectURL = redirectUrl;
        },
        setShouldOpenOnNewPage: (state, shouldOpenOnNewPage) => {
            state.shouldOpenOnNewPage = shouldOpenOnNewPage;
        },
        setPrevPagePopupOpened: (state, prevPagePopupOpened) => {
            state.prevPagePopupOpened = prevPagePopupOpened;
        },
        setHasOpenedOnWindowOut: (state, hasOpenedOnWindowOut) => {
            state.hasOpenedOnWindowOut = hasOpenedOnWindowOut;
        },
    },
};
